import React, { useState } from 'react'
import { Button, Tooltip } from '@surecompanies/core_components'
import { EyeOutlined, CheckOutlined, LoadingOutlined } from '@ant-design/icons'
import type { ICellRendererParams } from '@ag-grid-community/core'

interface RowActionCellParams extends ICellRendererParams {
  onView: (row: Record<string, unknown>) => Promise<void>
  onApprove: (row: Record<string, unknown>) => Promise<void>
}

export function RowActionCell(params: RowActionCellParams) {
  const [isApproving, setIsApproving] = useState(false)
  const [isViewLoading, setIsViewLoading] = useState(false)
  const row = params.data as Record<string, unknown> | undefined
  if (!row) return null
  const isApproved = row.__overrideStatus === 'APPROVED'

  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      <Tooltip title="View override">
        <Button
          icon={isViewLoading ? <LoadingOutlined /> : <EyeOutlined />}
          size="small"
          type="text"
          disabled={isViewLoading}
          onClick={async (e) => {
            e.stopPropagation()
            setIsViewLoading(true)
            try {
              await params.onView(row)
            } finally {
              setIsViewLoading(false)
            }
          }}
        />
      </Tooltip>
      <Tooltip
        title={isApproved ? 'Already approved' : 'Approve row as override'}
      >
        <Button
          icon={isApproving ? <LoadingOutlined /> : <CheckOutlined />}
          size="small"
          type="text"
          disabled={isApproved || isApproving}
          style={isApproved ? { color: '#10b981' } : undefined}
          onClick={async (e) => {
            e.stopPropagation()
            if (isApproved || isApproving) return
            setIsApproving(true)
            try {
              await params.onApprove(row)
            } catch {
              // error notification handled by parent
            } finally {
              setIsApproving(false)
            }
          }}
        />
      </Tooltip>
    </div>
  )
}
